<template>
  <div class="deta">

    <div class="make_follow">
      <ul class="follow_list">
        <li class="follow_list_li">
          <div class="title">
            <p class="blue">{{ deta.reportType != null ? $store.state.type.filter((item) => { return item.dictKey == deta.reportType })[0].dictValue : null }}报告 - {{ deta.name }}</p>
            <p>{{ deta.createTime }}</p>
          </div>
          <ul class="content">
            <li v-for="(items,index) in deta.followAdviceList" :key="index" >
              <h2>{{ index + 1 }}.{{ items.deptName }}</h2>
              <div class="reason" v-for="(itemss,indexs) in items.adviceList" :key="indexs" >
                <p>
                  <span>诊断原因</span>
                  {{ itemss.reason }}
                </p>
                <p>
                  <span>医生建议</span>
                  {{ itemss.advice }}
                </p>
                <p>
                  <span>建议复诊时间</span>
                  {{ itemss.reviewDate }}
                </p>
              </div>
            </li>
          </ul>
        </li>
      </ul>
      <div class="make_follow_form">
<!--        <p class="make_follow_form_title">建议复诊时间：2021-01-20</p>-->

        <van-form ref="form" @submit="onSubmit(form)" :show-error="false" label-width="60" >

          <van-field
              class="grey_input"
              readonly
              clickable
              name="appointmentDate"
              :value="form.appointDate"
              label="预约日期"
              placeholder="请选择预约日期"
              @click="showPickerDate = true"
              :rules="[{ required: true, message: '请选择预约日期' }]"
          >
            <template #right-icon>
              <div>
                <p class="iconfont icon-xuanzeriqi"></p>
              </div>
            </template>
          </van-field>
          <van-popup v-model="showPickerDate" position="bottom">
            <van-datetime-picker
                type="date"
                title="选择年月日"
                :min-date="minDate"
                @confirm="onConfirmDate"
                @cancel="showPickerDate = false"
            />
          </van-popup>

          <van-field
              class="grey_input"
              readonly
              clickable
              name="appointmentPeriod"
              :value="form.appointPeriod ? $store.state.appointFolllow.filter((item) => { return item.dictKey == form.appointPeriod })[0].dictValue : null "
              label="预约时段"
              placeholder="请选择预约时段"
              @click="showPickerTime = true"
              :rules="[{ required: true, message: '请选择预约时段' }]"
          >
            <template #right-icon>
              <div>
                <p :class="( showPickerTime ? 'icon-shangxiaxuanze-zhuan' : '' )"  class="iconfont icon-shangxiaxuanze"></p>
              </div>
            </template>
          </van-field>
          <van-popup v-model="showPickerTime" position="bottom">
            <van-picker
                show-toolbar
                value-key="dictValue"
                :columns="$store.state.appointFolllow"
                @confirm="onConfirmTime"
                @cancel="showPickerTime = false"
            />
          </van-popup>

          <van-field
              readonly
              clickable
              name="picker"
              :value="form.appointHospital ? $store.state.appointHospital.filter((item) => { return item.dictKey == form.appointHospital })[0].dictValue : null "
              label="预约地点"
              placeholder="请选择预约地点"
              :rules="[{ required: true, message: '请选择预约地点' }]"
              @click="showPickerHospital= true"
          >
            <template #right-icon>
              <div>
                <p class="iconfont icon-shangxiaxuanze" :class="( showPickerHospital ? 'icon-shangxiaxuanze-zhuan' : '' )" ></p>
              </div>
            </template>
          </van-field>
          <van-popup v-model="showPickerHospital" position="bottom">
            <van-picker
                show-toolbar
                value-key="dictValue"
                :columns="$store.state.appointHospital"
                @confirm="onConfirmHospital"
                @cancel="showPickerHospital = false"
            />
          </van-popup>

          <div class="button">
            <van-button round block type="info" native-type="submit">确认</van-button>
          </div>

        </van-form>

      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "FollowDeta",
  data() {
    return{
      form: {
        reportId: this.$route.query.id,
        appointDate: null, // 预约日期
        appointHospital: null, // 预约医院
        appointPeriod: null, // 预约时段
      },
      minDate: new Date(),
      showPickerDate: false,
      showPickerTime: false,
      showPickerHospital: false,
      deta: {
        followAdviceList: []
      }
    }
  },
  created() {
    // 日期
    this.minDate=this.minDate.setDate(this.minDate.getDate()+2);
    this.minDate=new Date(this.minDate);

    this.$store.dispatch("setType");
    this.$store.dispatch("setAppointFolllow");
    this.$store.dispatch("setAppointHospital");

    this.get_deta(this.$route.query.id);

  },
  mounted() {

  },
  methods: {
    get_deta(y) {
      console.log(y)
      this.$get("follow",y,true)
          .then(res => {
            if(res) {
              console.log(res);

              this.deta= res.data;

            }
          })
    },
    onSubmit(formName) {
      console.log(formName);
      this.$post("follow",formName)
        .then(res => {
          if(res) {
            console.log(res);
            this.$router.push({
              path: "/follow"
            })
          }
        })
    },
    onConfirmDate(e) {
      this.form.appointDate= this.formatDate(e);
      this.showPickerDate= false;
    },
    onConfirmTime(e) {
      this.form.appointPeriod= e.dictKey;
      this.showPickerTime= false;
    },
    onConfirmHospital(e) {
      this.form.appointHospital= e.dictKey;
      this.showPickerHospital= false;
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../../style/Nav/Follow";
  @import "../../style/Follow/FollowDeta";
</style>
